<template>
  <app-modal overflow @close="$emit('close')">
    <div class="p-4">
      <label class="form-check-label" v-if="isDelete">Delete recurring event:</label>
      <label class="form-check-label" v-else>Edit recurring event:</label>
      <div style="margin-left: 20px">
        <div class="app-form-row my-3">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              :checked="saveType === EventSaveTypes.CurrentOnly"
              @change="saveType = EventSaveTypes.CurrentOnly"
            />
            This event
          </label>
        </div>
        <div class="app-form-row my-3">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              :checked="saveType === EventSaveTypes.Future"
              @change="saveType = EventSaveTypes.Future"
            />
            This and following events
          </label>
        </div>
        <div class="app-form-row my-3">
          <label class="form-check-label">
            <input
              class="form-check-input"
              type="radio"
              :checked="saveType === EventSaveTypes.All"
              @change="saveType = EventSaveTypes.All"
            />
            All events
          </label>
        </div>
      </div>
      <div class="app-form-row mt-3 mb-0">
        <button class="btn btn-primary mr-3 ml-auto" @click.prevent="$emit('submit', saveType)">{{ actionLabel }}</button>
        <button class="btn btn-default" @click.prevent="$emit('close')">Cancel</button>
      </div>
    </div>
  </app-modal>
</template>

<script>
import { EventSaveTypes } from '@/components/desk/helpers'

export default {
  name: 'DeskEventSetDialog',
  data() {
    return {
      EventSaveTypes,
      saveType: EventSaveTypes.CurrentOnly
    }
  },
  props: {
    isDelete: { type: Boolean, default: false }
  },
  computed: {
    actionLabel() {
      return this.isDelete ? 'Delete' : 'Save'
    }
  }
}
</script>

<style scoped></style>
